module.exports = __webpack_public_path__ + "fonts/da2a4188af70964a33de11b965016278.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/scenes/TripDetails/components/RegionSelect/img/icon_europe_selected.svg
// module id = 1520
// module chunks = 0